import { render, staticRenderFns } from "./HomeSlides.vue?vue&type=template&id=a5f8d786&scoped=true&"
import script from "./HomeSlides.vue?vue&type=script&lang=js&"
export * from "./HomeSlides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f8d786",
  null
  
)

export default component.exports